// Identity colours (design/13-ownership-and-roles.md §6, design/08 §5): each
// person at a table has one, used for their focus highlights and roll-log
// entries. Players pick from this palette; the DM's colour is fixed and
// distinct from every entry in it, and the DM may override and lock a
// player's. Named so a person can say "I'm the teal one".
export const PALETTE = [
    { name: 'Crimson', hex: '#c0392b' },
    { name: 'Tangerine', hex: '#e67e22' },
    { name: 'Sunflower', hex: '#f1c40f' },
    { name: 'Emerald', hex: '#27ae60' },
    { name: 'Teal', hex: '#16a085' },
    { name: 'Sky', hex: '#2980b9' },
    { name: 'Indigo', hex: '#5b4fcf' },
    { name: 'Violet', hex: '#8e44ad' },
    { name: 'Rose', hex: '#e84393' },
    { name: 'Coral', hex: '#ff7f50' },
    { name: 'Lime', hex: '#8bc34a' },
    { name: 'Slate', hex: '#7f8c8d' },
];
/** The DM's colour: fixed, and not in the palette. */
export const DM_COLOUR = '#d4af37';
const HEX_RE = /^#[0-9a-f]{6}$/;
export function isPaletteColour(value) {
    return typeof value === 'string' && HEX_RE.test(value) && PALETTE.some((c) => c.hex === value);
}
/** The first palette colour nobody at the table holds, or the least-used one when all are taken. */
export function freeColour(taken) {
    const counts = new Map(PALETTE.map((c) => [c.hex, 0]));
    for (const t of taken)
        if (counts.has(t))
            counts.set(t, (counts.get(t) ?? 0) + 1);
    let best = PALETTE[0].hex;
    let bestCount = Number.POSITIVE_INFINITY;
    for (const c of PALETTE) {
        const n = counts.get(c.hex) ?? 0;
        if (n < bestCount) {
            best = c.hex;
            bestCount = n;
        }
    }
    return best;
}
//# sourceMappingURL=colours.js.map